export const isoDatetimeToDateString = (isoString: string) => {
  const parsedDate = isoString.replace(/T(.*)/, "");
  const [year, month, day] = parsedDate.split("-");

  return `${day}/${month}/${year}`;
};
